import { defineMessages, type MessageDescriptor } from 'react-intl-next';

import type { AnonymousAssetId } from './types';

export const messages: Record<AnonymousAssetId, MessageDescriptor> =
	defineMessages<AnonymousAssetId>({
		alligator: {
			id: 'platform.anonymous-asset-name.alligator',
			defaultMessage: 'Anonymous Alligator',
			description: 'The nickname for when the user is anonymous, with a alligator svg',
		},
		alpaca: {
			id: 'platform.anonymous-asset-name.alpaca',
			defaultMessage: 'Anonymous Alpaca',
			description: 'The nickname for when the user is anonymous, with a alpaca svg',
		},
		ape: {
			id: 'platform.anonymous-asset-name.ape',
			defaultMessage: 'Anonymous Ape',
			description: 'The nickname for when the user is anonymous, with a ape svg',
		},
		apple: {
			id: 'platform.anonymous-asset-name.apple',
			defaultMessage: 'Anonymous Apple',
			description: 'The nickname for when the user is anonymous, with a apple svg',
		},
		avocado: {
			id: 'platform.anonymous-asset-name.avocado',
			defaultMessage: 'Anonymous Avocado',
			description: 'The nickname for when the user is anonymous, with a avocado svg',
		},
		baboon: {
			id: 'platform.anonymous-asset-name.baboon',
			defaultMessage: 'Anonymous Baboon',
			description: 'The nickname for when the user is anonymous, with a baboon svg',
		},
		badger: {
			id: 'platform.anonymous-asset-name.badger',
			defaultMessage: 'Anonymous Badger',
			description: 'The nickname for when the user is anonymous, with a badger svg',
		},
		bat: {
			id: 'platform.anonymous-asset-name.bat',
			defaultMessage: 'Anonymous Bat',
			description: 'The nickname for when the user is anonymous, with a bat svg',
		},
		bear: {
			id: 'platform.anonymous-asset-name.bear',
			defaultMessage: 'Anonymous Bear',
			description: 'The nickname for when the user is anonymous, with a bear svg',
		},
		beaver: {
			id: 'platform.anonymous-asset-name.beaver',
			defaultMessage: 'Anonymous Beaver',
			description: 'The nickname for when the user is anonymous, with a beaver svg',
		},
		bee: {
			id: 'platform.anonymous-asset-name.bee',
			defaultMessage: 'Anonymous Bee',
			description: 'The nickname for when the user is anonymous, with a bee svg',
		},
		bird: {
			id: 'platform.anonymous-asset-name.bird',
			defaultMessage: 'Anonymous Bird',
			description: 'The nickname for when the user is anonymous, with a bird svg',
		},
		bison: {
			id: 'platform.anonymous-asset-name.bison',
			defaultMessage: 'Anonymous Bison',
			description: 'The nickname for when the user is anonymous, with a bison svg',
		},
		blobfish: {
			id: 'platform.anonymous-asset-name.blobfish',
			defaultMessage: 'Anonymous Blobfish',
			description: 'The nickname for when the user is anonymous, with a blobfish svg',
		},
		blossom: {
			id: 'platform.anonymous-asset-name.blossom',
			defaultMessage: 'Anonymous Blossom',
			description: 'The nickname for when the user is anonymous, with a blossom svg',
		},
		blowfish: {
			id: 'platform.anonymous-asset-name.blowfish',
			defaultMessage: 'Anonymous Blowfish',
			description: 'The nickname for when the user is anonymous, with a blowfish svg',
		},
		blueberries: {
			id: 'platform.anonymous-asset-name.blueberries',
			defaultMessage: 'Anonymous Blueberries',
			description: 'The nickname for when the user is anonymous, with a blueberries svg',
		},
		boar: {
			id: 'platform.anonymous-asset-name.boar',
			defaultMessage: 'Anonymous Boar',
			description: 'The nickname for when the user is anonymous, with a boar svg',
		},
		broccoli: {
			id: 'platform.anonymous-asset-name.broccoli',
			defaultMessage: 'Anonymous Broccoli',
			description: 'The nickname for when the user is anonymous, with a broccoli svg',
		},
		buffalo: {
			id: 'platform.anonymous-asset-name.buffalo',
			defaultMessage: 'Anonymous Buffalo',
			description: 'The nickname for when the user is anonymous, with a buffalo svg',
		},
		bug: {
			id: 'platform.anonymous-asset-name.bug',
			defaultMessage: 'Anonymous Bug',
			description: 'The nickname for when the user is anonymous, with a bug svg',
		},
		bull: {
			id: 'platform.anonymous-asset-name.bull',
			defaultMessage: 'Anonymous Bull',
			description: 'The nickname for when the user is anonymous, with a bull svg',
		},
		bunny: {
			id: 'platform.anonymous-asset-name.bunny',
			defaultMessage: 'Anonymous Bunny',
			description: 'The nickname for when the user is anonymous, with a bunny svg',
		},
		butterfly: {
			id: 'platform.anonymous-asset-name.butterfly',
			defaultMessage: 'Anonymous Butterfly',
			description: 'The nickname for when the user is anonymous, with a butterfly svg',
		},
		cactus: {
			id: 'platform.anonymous-asset-name.cactus',
			defaultMessage: 'Anonymous Cactus',
			description: 'The nickname for when the user is anonymous, with a cactus svg',
		},
		camel: {
			id: 'platform.anonymous-asset-name.camel',
			defaultMessage: 'Anonymous Camel',
			description: 'The nickname for when the user is anonymous, with a camel svg',
		},
		candy: {
			id: 'platform.anonymous-asset-name.candy',
			defaultMessage: 'Anonymous Candy',
			description: 'The nickname for when the user is anonymous, with a candy svg',
		},
		cantaloupe: {
			id: 'platform.anonymous-asset-name.cantaloupe',
			defaultMessage: 'Anonymous Cantaloupe',
			description: 'The nickname for when the user is anonymous, with a cantaloupe svg',
		},
		capsicum: {
			id: 'platform.anonymous-asset-name.capsicum',
			defaultMessage: 'Anonymous Capsicum',
			description: 'The nickname for when the user is anonymous, with a capsicum svg',
		},
		carrot: {
			id: 'platform.anonymous-asset-name.carrot',
			defaultMessage: 'Anonymous Carrot',
			description: 'The nickname for when the user is anonymous, with a carrot svg',
		},
		cat: {
			id: 'platform.anonymous-asset-name.cat',
			defaultMessage: 'Anonymous Cat',
			description: 'The nickname for when the user is anonymous, with a cat svg',
		},
		caterpiller: {
			id: 'platform.anonymous-asset-name.caterpiller',
			defaultMessage: 'Anonymous Caterpiller',
			description: 'The nickname for when the user is anonymous, with a caterpiller svg',
		},
		chameleon: {
			id: 'platform.anonymous-asset-name.chameleon',
			defaultMessage: 'Anonymous Chameleon',
			description: 'The nickname for when the user is anonymous, with a chameleon svg',
		},
		cherry: {
			id: 'platform.anonymous-asset-name.cherry',
			defaultMessage: 'Anonymous Cherry',
			description: 'The nickname for when the user is anonymous, with a cherry svg',
		},
		chili: {
			id: 'platform.anonymous-asset-name.chili',
			defaultMessage: 'Anonymous Chili',
			description: 'The nickname for when the user is anonymous, with a chili svg',
		},
		chimp: {
			id: 'platform.anonymous-asset-name.chimp',
			defaultMessage: 'Anonymous Chimp',
			description: 'The nickname for when the user is anonymous, with a chimp svg',
		},
		chimpanzee: {
			id: 'platform.anonymous-asset-name.chimpanzee',
			defaultMessage: 'Anonymous Chimpanzee',
			description: 'The nickname for when the user is anonymous, with a chimpanzee svg',
		},
		clover: {
			id: 'platform.anonymous-asset-name.clover',
			defaultMessage: 'Anonymous Clover',
			description: 'The nickname for when the user is anonymous, with a clover svg',
		},
		clownfish: {
			id: 'platform.anonymous-asset-name.clownfish',
			defaultMessage: 'Anonymous Clownfish',
			description: 'The nickname for when the user is anonymous, with a clownfish svg',
		},
		cobra: {
			id: 'platform.anonymous-asset-name.cobra',
			defaultMessage: 'Anonymous Cobra',
			description: 'The nickname for when the user is anonymous, with a cobra svg',
		},
		coconut: {
			id: 'platform.anonymous-asset-name.coconut',
			defaultMessage: 'Anonymous Coconut',
			description: 'The nickname for when the user is anonymous, with a coconut svg',
		},
		cod: {
			id: 'platform.anonymous-asset-name.cod',
			defaultMessage: 'Anonymous Cod',
			description: 'The nickname for when the user is anonymous, with a cod svg',
		},
		cookie: {
			id: 'platform.anonymous-asset-name.cookie',
			defaultMessage: 'Anonymous Cookie',
			description: 'The nickname for when the user is anonymous, with a cookie svg',
		},
		corn: {
			id: 'platform.anonymous-asset-name.corn',
			defaultMessage: 'Anonymous Corn',
			description: 'The nickname for when the user is anonymous, with a corn svg',
		},
		cow: {
			id: 'platform.anonymous-asset-name.cow',
			defaultMessage: 'Anonymous Cow',
			description: 'The nickname for when the user is anonymous, with a cow svg',
		},
		crab: {
			id: 'platform.anonymous-asset-name.crab',
			defaultMessage: 'Anonymous Crab',
			description: 'The nickname for when the user is anonymous, with a crab svg',
		},
		crocodile: {
			id: 'platform.anonymous-asset-name.crocodile',
			defaultMessage: 'Anonymous Crocodile',
			description: 'The nickname for when the user is anonymous, with a crocodile svg',
		},
		deer: {
			id: 'platform.anonymous-asset-name.deer',
			defaultMessage: 'Anonymous Deer',
			description: 'The nickname for when the user is anonymous, with a deer svg',
		},
		dinosaur: {
			id: 'platform.anonymous-asset-name.dinosaur',
			defaultMessage: 'Anonymous Dinosaur',
			description: 'The nickname for when the user is anonymous, with a dinosaur svg',
		},
		dodo: {
			id: 'platform.anonymous-asset-name.dodo',
			defaultMessage: 'Anonymous Dodo',
			description: 'The nickname for when the user is anonymous, with a dodo svg',
		},
		dog: {
			id: 'platform.anonymous-asset-name.dog',
			defaultMessage: 'Anonymous Dog',
			description: 'The nickname for when the user is anonymous, with a dog svg',
		},
		dolphin: {
			id: 'platform.anonymous-asset-name.dolphin',
			defaultMessage: 'Anonymous Dolphin',
			description: 'The nickname for when the user is anonymous, with a dolphin svg',
		},
		donut: {
			id: 'platform.anonymous-asset-name.donut',
			defaultMessage: 'Anonymous Donut',
			description: 'The nickname for when the user is anonymous, with a donut svg',
		},
		dragon: {
			id: 'platform.anonymous-asset-name.dragon',
			defaultMessage: 'Anonymous Dragon',
			description: 'The nickname for when the user is anonymous, with a dragon svg',
		},
		duck: {
			id: 'platform.anonymous-asset-name.duck',
			defaultMessage: 'Anonymous Duck',
			description: 'The nickname for when the user is anonymous, with a duck svg',
		},
		elephant: {
			id: 'platform.anonymous-asset-name.elephant',
			defaultMessage: 'Anonymous Elephant',
			description: 'The nickname for when the user is anonymous, with a elephant svg',
		},
		elk: {
			id: 'platform.anonymous-asset-name.elk',
			defaultMessage: 'Anonymous Elk',
			description: 'The nickname for when the user is anonymous, with a elk svg',
		},
		fish: {
			id: 'platform.anonymous-asset-name.fish',
			defaultMessage: 'Anonymous Fish',
			description: 'The nickname for when the user is anonymous, with a fish svg',
		},
		flamingo: {
			id: 'platform.anonymous-asset-name.flamingo',
			defaultMessage: 'Anonymous Flamingo',
			description: 'The nickname for when the user is anonymous, with a flamingo svg',
		},
		fox: {
			id: 'platform.anonymous-asset-name.fox',
			defaultMessage: 'Anonymous Fox',
			description: 'The nickname for when the user is anonymous, with a fox svg',
		},
		frog: {
			id: 'platform.anonymous-asset-name.frog',
			defaultMessage: 'Anonymous Frog',
			description: 'The nickname for when the user is anonymous, with a frog svg',
		},
		gecko: {
			id: 'platform.anonymous-asset-name.gecko',
			defaultMessage: 'Anonymous Gecko',
			description: 'The nickname for when the user is anonymous, with a gecko svg',
		},
		giraffe: {
			id: 'platform.anonymous-asset-name.giraffe',
			defaultMessage: 'Anonymous Giraffe',
			description: 'The nickname for when the user is anonymous, with a giraffe svg',
		},
		gorilla: {
			id: 'platform.anonymous-asset-name.gorilla',
			defaultMessage: 'Anonymous Gorilla',
			description: 'The nickname for when the user is anonymous, with a gorilla svg',
		},
		grape: {
			id: 'platform.anonymous-asset-name.grape',
			defaultMessage: 'Anonymous Grape',
			description: 'The nickname for when the user is anonymous, with a grape svg',
		},
		hammerhead: {
			id: 'platform.anonymous-asset-name.hammerhead',
			defaultMessage: 'Anonymous Hammerhead',
			description: 'The nickname for when the user is anonymous, with a hammerhead svg',
		},
		hedgehog: {
			id: 'platform.anonymous-asset-name.hedgehog',
			defaultMessage: 'Anonymous Hedgehog',
			description: 'The nickname for when the user is anonymous, with a hedgehog svg',
		},
		hippo: {
			id: 'platform.anonymous-asset-name.hippo',
			defaultMessage: 'Anonymous Hippo',
			description: 'The nickname for when the user is anonymous, with a hippo svg',
		},
		kangaroo: {
			id: 'platform.anonymous-asset-name.kangaroo',
			defaultMessage: 'Anonymous Kangaroo',
			description: 'The nickname for when the user is anonymous, with a kangaroo svg',
		},
		kitten: {
			id: 'platform.anonymous-asset-name.kitten',
			defaultMessage: 'Anonymous Kitten',
			description: 'The nickname for when the user is anonymous, with a kitten svg',
		},
		kiwi: {
			id: 'platform.anonymous-asset-name.kiwi',
			defaultMessage: 'Anonymous Kiwi',
			description: 'The nickname for when the user is anonymous, with a kiwi svg',
		},
		koala: {
			id: 'platform.anonymous-asset-name.koala',
			defaultMessage: 'Anonymous Koala',
			description: 'The nickname for when the user is anonymous, with a koala svg',
		},
		lemon: {
			id: 'platform.anonymous-asset-name.lemon',
			defaultMessage: 'Anonymous Lemon',
			description: 'The nickname for when the user is anonymous, with a lemon svg',
		},
		leopard: {
			id: 'platform.anonymous-asset-name.leopard',
			defaultMessage: 'Anonymous Leopard',
			description: 'The nickname for when the user is anonymous, with a leopard svg',
		},
		lettuce: {
			id: 'platform.anonymous-asset-name.lettuce',
			defaultMessage: 'Anonymous Lettuce',
			description: 'The nickname for when the user is anonymous, with a lettuce svg',
		},
		lion: {
			id: 'platform.anonymous-asset-name.lion',
			defaultMessage: 'Anonymous Lion',
			description: 'The nickname for when the user is anonymous, with a lion svg',
		},
		lizard: {
			id: 'platform.anonymous-asset-name.lizard',
			defaultMessage: 'Anonymous Lizard',
			description: 'The nickname for when the user is anonymous, with a lizard svg',
		},
		llama: {
			id: 'platform.anonymous-asset-name.llama',
			defaultMessage: 'Anonymous Llama',
			description: 'The nickname for when the user is anonymous, with a llama svg',
		},
		lobster: {
			id: 'platform.anonymous-asset-name.lobster',
			defaultMessage: 'Anonymous Lobster',
			description: 'The nickname for when the user is anonymous, with a lobster svg',
		},
		macaque: {
			id: 'platform.anonymous-asset-name.macaque',
			defaultMessage: 'Anonymous Macaque',
			description: 'The nickname for when the user is anonymous, with a macaque svg',
		},
		mango: {
			id: 'platform.anonymous-asset-name.mango',
			defaultMessage: 'Anonymous Mango',
			description: 'The nickname for when the user is anonymous, with a mango svg',
		},
		melon: {
			id: 'platform.anonymous-asset-name.melon',
			defaultMessage: 'Anonymous Melon',
			description: 'The nickname for when the user is anonymous, with a melon svg',
		},
		millipede: {
			id: 'platform.anonymous-asset-name.millipede',
			defaultMessage: 'Anonymous Millipede',
			description: 'The nickname for when the user is anonymous, with a millipede svg',
		},
		monkey: {
			id: 'platform.anonymous-asset-name.monkey',
			defaultMessage: 'Anonymous Monkey',
			description: 'The nickname for when the user is anonymous, with a monkey svg',
		},
		mouse: {
			id: 'platform.anonymous-asset-name.mouse',
			defaultMessage: 'Anonymous Mouse',
			description: 'The nickname for when the user is anonymous, with a mouse svg',
		},
		octopus: {
			id: 'platform.anonymous-asset-name.octopus',
			defaultMessage: 'Anonymous Octopus',
			description: 'The nickname for when the user is anonymous, with a octopus svg',
		},
		olive: {
			id: 'platform.anonymous-asset-name.olive',
			defaultMessage: 'Anonymous Olive',
			description: 'The nickname for when the user is anonymous, with a olive svg',
		},
		orange: {
			id: 'platform.anonymous-asset-name.orange',
			defaultMessage: 'Anonymous Orange',
			description: 'The nickname for when the user is anonymous, with a orange svg',
		},
		orangutan: {
			id: 'platform.anonymous-asset-name.orangutan',
			defaultMessage: 'Anonymous Orangutan',
			description: 'The nickname for when the user is anonymous, with a orangutan svg',
		},
		otter: {
			id: 'platform.anonymous-asset-name.otter',
			defaultMessage: 'Anonymous Otter',
			description: 'The nickname for when the user is anonymous, with a otter svg',
		},
		owl: {
			id: 'platform.anonymous-asset-name.owl',
			defaultMessage: 'Anonymous Owl',
			description: 'The nickname for when the user is anonymous, with a owl svg',
		},
		ox: {
			id: 'platform.anonymous-asset-name.ox',
			defaultMessage: 'Anonymous Ox',
			description: 'The nickname for when the user is anonymous, with a ox svg',
		},
		oyster: {
			id: 'platform.anonymous-asset-name.oyster',
			defaultMessage: 'Anonymous Oyster',
			description: 'The nickname for when the user is anonymous, with a oyster svg',
		},
		panda: {
			id: 'platform.anonymous-asset-name.panda',
			defaultMessage: 'Anonymous Panda',
			description: 'The nickname for when the user is anonymous, with a panda svg',
		},
		parrot: {
			id: 'platform.anonymous-asset-name.parrot',
			defaultMessage: 'Anonymous Parrot',
			description: 'The nickname for when the user is anonymous, with a parrot svg',
		},
		peacock: {
			id: 'platform.anonymous-asset-name.peacock',
			defaultMessage: 'Anonymous Peacock',
			description: 'The nickname for when the user is anonymous, with a peacock svg',
		},
		pear: {
			id: 'platform.anonymous-asset-name.pear',
			defaultMessage: 'Anonymous Pear',
			description: 'The nickname for when the user is anonymous, with a pear svg',
		},
		penguin: {
			id: 'platform.anonymous-asset-name.penguin',
			defaultMessage: 'Anonymous Penguin',
			description: 'The nickname for when the user is anonymous, with a penguin svg',
		},
		pig: {
			id: 'platform.anonymous-asset-name.pig',
			defaultMessage: 'Anonymous Pig',
			description: 'The nickname for when the user is anonymous, with a pig svg',
		},
		pineapple: {
			id: 'platform.anonymous-asset-name.pineapple',
			defaultMessage: 'Anonymous Pineapple',
			description: 'The nickname for when the user is anonymous, with a pineapple svg',
		},
		poodle: {
			id: 'platform.anonymous-asset-name.poodle',
			defaultMessage: 'Anonymous Poodle',
			description: 'The nickname for when the user is anonymous, with a poodle svg',
		},
		puppy: {
			id: 'platform.anonymous-asset-name.puppy',
			defaultMessage: 'Anonymous Puppy',
			description: 'The nickname for when the user is anonymous, with a puppy svg',
		},
		python: {
			id: 'platform.anonymous-asset-name.python',
			defaultMessage: 'Anonymous Python',
			description: 'The nickname for when the user is anonymous, with a python svg',
		},
		rabbit: {
			id: 'platform.anonymous-asset-name.rabbit',
			defaultMessage: 'Anonymous Rabbit',
			description: 'The nickname for when the user is anonymous, with a rabbit svg',
		},
		raccoon: {
			id: 'platform.anonymous-asset-name.raccoon',
			defaultMessage: 'Anonymous Raccoon',
			description: 'The nickname for when the user is anonymous, with a raccoon svg',
		},
		rat: {
			id: 'platform.anonymous-asset-name.rat',
			defaultMessage: 'Anonymous Rat',
			description: 'The nickname for when the user is anonymous, with a rat svg',
		},
		rhino: {
			id: 'platform.anonymous-asset-name.rhino',
			defaultMessage: 'Anonymous Rhino',
			description: 'The nickname for when the user is anonymous, with a rhino svg',
		},
		robot: {
			id: 'platform.anonymous-asset-name.robot',
			defaultMessage: 'Anonymous Robot',
			description: 'The nickname for when the user is anonymous, with a robot svg',
		},
		rose: {
			id: 'platform.anonymous-asset-name.rose',
			defaultMessage: 'Anonymous Rose',
			description: 'The nickname for when the user is anonymous, with a rose svg',
		},
		seal: {
			id: 'platform.anonymous-asset-name.seal',
			defaultMessage: 'Anonymous Seal',
			description: 'The nickname for when the user is anonymous, with a seal svg',
		},
		seedling: {
			id: 'platform.anonymous-asset-name.seedling',
			defaultMessage: 'Anonymous Seedling',
			description: 'The nickname for when the user is anonymous, with a seedling svg',
		},
		shark: {
			id: 'platform.anonymous-asset-name.shark',
			defaultMessage: 'Anonymous Shark',
			description: 'The nickname for when the user is anonymous, with a shark svg',
		},
		shrimp: {
			id: 'platform.anonymous-asset-name.shrimp',
			defaultMessage: 'Anonymous Shrimp',
			description: 'The nickname for when the user is anonymous, with a shrimp svg',
		},
		skunk: {
			id: 'platform.anonymous-asset-name.skunk',
			defaultMessage: 'Anonymous Skunk',
			description: 'The nickname for when the user is anonymous, with a skunk svg',
		},
		sloth: {
			id: 'platform.anonymous-asset-name.sloth',
			defaultMessage: 'Anonymous Sloth',
			description: 'The nickname for when the user is anonymous, with a sloth svg',
		},
		snail: {
			id: 'platform.anonymous-asset-name.snail',
			defaultMessage: 'Anonymous Snail',
			description: 'The nickname for when the user is anonymous, with a snail svg',
		},
		snake: {
			id: 'platform.anonymous-asset-name.snake',
			defaultMessage: 'Anonymous Snake',
			description: 'The nickname for when the user is anonymous, with a snake svg',
		},
		snowman: {
			id: 'platform.anonymous-asset-name.snowman',
			defaultMessage: 'Anonymous Snowman',
			description: 'The nickname for when the user is anonymous, with a snowman svg',
		},
		squid: {
			id: 'platform.anonymous-asset-name.squid',
			defaultMessage: 'Anonymous Squid',
			description: 'The nickname for when the user is anonymous, with a squid svg',
		},
		squirrel: {
			id: 'platform.anonymous-asset-name.squirrel',
			defaultMessage: 'Anonymous Squirrel',
			description: 'The nickname for when the user is anonymous, with a squirrel svg',
		},
		strawberry: {
			id: 'platform.anonymous-asset-name.strawberry',
			defaultMessage: 'Anonymous Strawberry',
			description: 'The nickname for when the user is anonymous, with a strawberry svg',
		},
		sunfish: {
			id: 'platform.anonymous-asset-name.sunfish',
			defaultMessage: 'Anonymous Sunfish',
			description: 'The nickname for when the user is anonymous, with a sunfish svg',
		},
		sunflower: {
			id: 'platform.anonymous-asset-name.sunflower',
			defaultMessage: 'Anonymous Sunflower',
			description: 'The nickname for when the user is anonymous, with a sunflower svg',
		},
		tiger: {
			id: 'platform.anonymous-asset-name.tiger',
			defaultMessage: 'Anonymous Tiger',
			description: 'The nickname for when the user is anonymous, with a tiger svg',
		},
		tomato: {
			id: 'platform.anonymous-asset-name.tomato',
			defaultMessage: 'Anonymous Tomato',
			description: 'The nickname for when the user is anonymous, with a tomato svg',
		},
		tortoise: {
			id: 'platform.anonymous-asset-name.tortoise',
			defaultMessage: 'Anonymous Tortoise',
			description: 'The nickname for when the user is anonymous, with a tortoise svg',
		},
		tree: {
			id: 'platform.anonymous-asset-name.tree',
			defaultMessage: 'Anonymous Tree',
			description: 'The nickname for when the user is anonymous, with a tree svg',
		},
		trex: {
			id: 'platform.anonymous-asset-name.trex',
			defaultMessage: 'Anonymous T-rex',
			description: 'The nickname for when the user is anonymous, with a trex svg',
		},
		trout: {
			id: 'platform.anonymous-asset-name.trout',
			defaultMessage: 'Anonymous Trout',
			description: 'The nickname for when the user is anonymous, with a trout svg',
		},
		turkey: {
			id: 'platform.anonymous-asset-name.turkey',
			defaultMessage: 'Anonymous Turkey',
			description: 'The nickname for when the user is anonymous, with a turkey svg',
		},
		turtle: {
			id: 'platform.anonymous-asset-name.turtle',
			defaultMessage: 'Anonymous Turtle',
			description: 'The nickname for when the user is anonymous, with a turtle svg',
		},
		wasp: {
			id: 'platform.anonymous-asset-name.wasp',
			defaultMessage: 'Anonymous Wasp',
			description: 'The nickname for when the user is anonymous, with a wasp svg',
		},
		watermelon: {
			id: 'platform.anonymous-asset-name.watermelon',
			defaultMessage: 'Anonymous Watermelon',
			description: 'The nickname for when the user is anonymous, with a watermelon svg',
		},
		whale: {
			id: 'platform.anonymous-asset-name.whale',
			defaultMessage: 'Anonymous Whale',
			description: 'The nickname for when the user is anonymous, with a whale svg',
		},
		wolf: {
			id: 'platform.anonymous-asset-name.wolf',
			defaultMessage: 'Anonymous Wolf',
			description: 'The nickname for when the user is anonymous, with a wolf svg',
		},
	});
